import * as Long from 'long';
import { InfoKeys } from '../consts.js';
import { im_proto } from '../../proto/index.js';
import { ContextClassBase } from '../service/RuntimeContext.js';

class Participant extends ContextClassBase {
    constructor() {
        super(...arguments);
        // read receipt
        /** 用户在会话内的最小可拉取位置 */
        this.minIndex = Long.ZERO;
        this._readIndex = Long.ZERO;
        this._readOrder = Long.ZERO;
    }
    /** 会话内成员最近一条已读消息的序号 */
    get readIndex() {
        return this._readIndex;
    }
    set readIndex(val) {
        if (val && val.gt(this._readIndex)) {
            this._readIndex = val;
        }
    }
    get readOrder() {
        return this._readOrder;
    }
    set readOrder(val) {
        if (val && val.gt(this._readOrder)) {
            this._readOrder = val;
        }
    }
    /** 是否是自己 */
    get isSelf() {
        return this.userId === this.ctx.option.userId;
    }
    get ext() {
        if (!this.innerExt) {
            this.innerExt = {};
        }
        return this.innerExt;
    }
    /** @internal */
    set ext(val) {
        this.innerExt = val;
    }
    static featLocalParticipant(local, server) {
        if (local.userId !== server.userId) {
            return local;
        }
        local.secUid = server.secUid;
        local.role = server.role;
        local.alias = server.alias;
        local.sortOrder = server.sortOrder;
        local.blocked = server.blocked;
        local.leftBlockTime = server.leftBlockTime;
        // 不会回退
        local.readIndex = server.readIndex;
        local.readOrder = server.readOrder;
        local.ext = Object.assign(local.ext, server.ext);
        return local;
    }
    static fromServerParticipant(ctx, p, conv, logid) {
        var _a, _b, _c, _d;
        const local = new Participant(ctx);
        local.userId = p.user_id.toString();
        local.secUid = p.sec_uid;
        local.role = (_a = p.role) !== null && _a !== void 0 ? _a : undefined;
        local.alias = (_b = p.alias) !== null && _b !== void 0 ? _b : undefined;
        local.sortOrder = (_c = p.sort_order) !== null && _c !== void 0 ? _c : undefined;
        local.blocked = p.blocked === im_proto.BlockStatus.BLOCK ? true : false;
        local.leftBlockTime = (_d = p.left_block_time) !== null && _d !== void 0 ? _d : undefined;
        local.conversationId = conv.id;
        local.conversationType = conv.type;
        if (logid !== undefined && local.ctx.option.debug) {
            local.ext[InfoKeys.LocalLogId] = logid;
        }
        return local;
    }
    static fakeParticipant(ctx, userId, conv) {
        const member = new Participant(ctx);
        member.conversationId = conv.id;
        member.conversationType = conv.type;
        member.readIndex = Long.ZERO;
        member.minIndex = Long.ZERO;
        member.userId = userId;
        return member;
    }
}

export { Participant };
//# sourceMappingURL=Participant.js.map
